import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';

import { ContentZonesService } from '@sm360/widget-commons-core-services';

import 'login/components/Transaction/TransactionSummaryUnit/TransactionSummaryUnit.scss';

const TransactionSummaryUnit = ({ itemSlug, isCompleted, onClick }) => {
    const icon = ContentZonesService.getContentZone('widget.transaction', `${itemSlug}.icon`).getValue();
    const label = ContentZonesService.getContentZone('widget.transaction', `${itemSlug}.label`).getValue();
    const classNames = ['TransactionSummaryUnit--single'];

    if (isCompleted) {
        classNames.push('is-validate');
    }

    return (
        <li className={classNames.join(' ')} data-test={itemSlug}>
            <button onClick={onClick}>
                <div className="wrapper-icon">
                    <img src={icon} alt={label} />
                </div>
                <div className="validFlag">
                    <icon className="icon-Crochet" />
                </div>
            </button>
        </li>
    );
};

TransactionSummaryUnit.propTypes = {
    itemSlug: PropTypes.string.isRequired,
    isCompleted: PropTypes.bool,
    onClick: PropTypes.func,
};

TransactionSummaryUnit.defaultProps = {
    isCompleted: false,
    onClick: noop,
};

TransactionSummaryUnit.displayName = 'TransactionSummaryUnit';

export default TransactionSummaryUnit;
